import "./login.scss";

import { useRef, useState, useEffect} from "react";
import { useNavigate,useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

import axios from '../../api/axios';
const LOGIN_URL = '/auth';

const Login = () =>{
  const {setAuth} = useAuth();
  const userRef = useRef();
  const errRef = useRef();

  const [username, setUser] = useState('');
  const [paswd, setPwd] = useState('');
  const [errMsg, setErrMsg] = useState('');

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/cpanel/manager/dashboard";

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg('');
  }, [username, paswd]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(LOGIN_URL,
        JSON.stringify({username,paswd}),
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true
        }
      );

      console.log(JSON.stringify(response?.data));
    
      const accessToken = response?.data?.accessToken;
      const roles = response?.data?.roles;
      const fullName = response?.data?.fullName;
    

      setAuth({username,paswd,fullName,roles,accessToken});
      setUser('');
      setPwd('');
      navigate(from,{replace:true});

    } catch (error) {
      if(!error?.response){
        setErrMsg('No Server Response');
      }else if(error.response?.status === 400){
        setErrMsg('Must enter the Username and Password!');
      }else if(error.response?.status === 401){
        setErrMsg('Invalid Username or Password!');
      }else{
        setErrMsg('Login Failed');
      }
      errRef.current.focus();
    }
    
  }

  return (

    <section className="login-container">
      <div className="login-box">
        <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              ref={userRef}
              autoComplete="off"
              onChange={(e) => setUser(e.target.value)}
              value={username}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              onChange={(e) => setPwd(e.target.value)}
              value={paswd}
              required
            />
          </div>

          <button>Sign In</button>
        </form>
      </div>
    </section>

  )
}


export default Login